/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { OasHeader } from './OasHeader';

/**
 * @author vvilerio
 * @class
 */
export interface IOasHeaderParent {
    /**
     * Creates a  header.
     * @param {string} name
     * @return {OasHeader}
     */
    createHeader(name : string) : OasHeader;

    /**
     * Adds a  header.
     * @param {string} name
     * @param {OasHeader} header
     */
    addHeader(name : string, header : OasHeader);

    /**
     * Gets a single  header by name.
     * @param {string} name
     * @return {OasHeader}
     */
    getHeader(name : string) : OasHeader;

    /**
     * Removes a single  header and returns it.  This may return null or undefined if none found.
     * @param {string} name
     * @return {OasHeader}
     */
    removeHeader(name : string) : OasHeader;

    /**
     * Gets a list of all  headers.
     * @return {OasHeader[]}
     */
    getHeaders() : Array<OasHeader>;
}


